import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { IAddress } from './address'
import { ODataService } from 'common-services'

export interface IFacility extends IModelBase {
  Name: string
  MailingAddressId: number
  MailingAddress: IAddress
  PhysicalAddressId: number
  PhysicalAddress: IAddress
}

@Injectable()
export class FacilityODataService extends ODataService<IFacility> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'Facilities'
  }
}
